import { call, put, takeEvery } from 'redux-saga/effects';
import callAdapter from '@/utils/sagaHelper';
import { fetchDictionaryMarkdownError, fetchDictionaryMarkdownSuccess } from '../actions';
import actions from '../constants';
import DictionaryMarkdownService from '../service';

export function* markdown({ category, code, datasetCode }) {
  const { response, error } = yield call(callAdapter, DictionaryMarkdownService.markdown(datasetCode, code));
  if (error) {
    yield put(fetchDictionaryMarkdownError(category, code, error));
  } else {
    yield put(fetchDictionaryMarkdownSuccess(category, code, response));
  }
}

export default function* dictionaryMarkdownApi() {
  yield takeEvery(actions.FETCH_DICTIONARY_MARKDOWN, markdown);
}
